
import { defineComponent } from 'vue'
import Viewer from 'viewerjs'
import ProductAdvantages from '@/components/ProductAdvantages.vue'
import backgroundSection from '@/components/home/backgroundSection/index.vue'
import BackToTop from '@/components/BackToTop.vue'
import 'viewerjs/dist/viewer.css'

export default defineComponent({
  components: {
    ProductAdvantages, BackToTop, backgroundSection
  },
  name: 'Landing',
  data: () => ({
    iphoneBackgroundImage: require('@/assets/images/iphone-bg.svg'),
    iphoneList: [
      require('@/assets/images/iphone-1.svg'),
      require('@/assets/images/iphone-2.svg'),
      require('@/assets/images/iphone-3.svg'),
      require('@/assets/images/iphone-7.svg'),
      require('@/assets/images/iphone-5.svg'),
      require('@/assets/images/iphone-6.svg')

    ],
    success: require('@/assets/images/success.png'),
    speed: require('@/assets/images/speed.png'),
    price: require('@/assets/images/price.png'),
    internet: require('@/assets/images/internet.png'),
    interfaces: require('@/assets/images/interface.png'),
    report: require('@/assets/images/report.png'),
    functions: require('@/assets/images/function.png'),
    service: require('@/assets/images/service.png'),
    top: require('@/assets/images/top.svg')
  }),
  mounted() {
    const viewer = new Viewer(document.getElementById('iphone-list') as HTMLElement, {
      button: true,
      toolbar: false,
      title: false,
      viewed() {
        viewer.zoomTo(1)
      }
    })
  },
  methods: {
    isUsingPhone() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)) return true
      return false
    }
  },
  computed: {
    qqHref() {
      if (this.isUsingPhone()) {
        return 'mqqwpa://im/chat?chat_type=wpa&uin=814152521&version=1&src_type=web&web_src=oicqzone.com'
      }
      return 'http://wpa.qq.com/msgrd?v=3&uin=814152521&site=oicqzone.com&menu=yes'
    },
    productList() {
      const productList = [
        {
          img: this.success,
          title: '成功率高，95+%到达率',
          content: '优质国际通道，95+%到达率（号码不在服务区除外）'
        },
        {
          img: this.speed,
          title: '速度快，5秒快速送达',
          content: '发送速度快，国际短信3-5秒送达，告别苦苦等待的烦恼'
        },
        {
          img: this.price,
          title: '明码标价，短信资费便宜+',
          content: '价格超实惠，明码标价，充值越多价格越划算'
        },
        {
          img: this.internet,
          title: '三网合一，通道稳定',
          content: '移动、联通、电信三网合一，国际短信专属通道，不堵塞，性能稳定'
        },
        {
          img: this.interfaces,
          title: '通用短信接口，快速接入',
          content: '详细的短信接口文档及demo，支持JAVA、PHP、C++等各种开发语言,15分钟快速接入'
        },
        {
          img: this.report,
          title: '即时状态报告',
          content: '实时监控发送状态，发送情况一目了然，随时随地监控短信发送与接收情况'
        },
        {
          img: this.functions,
          title: '功能强大，提供免费测试',
          content: '平台支持变量发送、号码批量导入、定时发送、数据统计等，提供免费测试'
        },
        {
          img: this.service,
          title: 'QQ、telegram群组多对一服务',
          content: '专业技术及服务团队，提供7x24小时服务支持，及时解答您遇到的问题'
        }
      ]
      return productList
    }
  }
})
